
















































































    import { Component, Prop } from 'vue-property-decorator';
    import { clearTimeout, setTimeout } from 'timers';
    
    import { mixins } from "vue-class-component";
    import SharedMixin from "@/mixins/SharedMixin";
    
    import { CustomerOrderStore } from "../../../CustomerOrderStore";
    
    import { CreateOfferEvaluationCustomerOrderHeaderCommand, OrderTipology } from "@/services/iOrderService";
    import { SharedModule } from "@/feature/Shared/store";
    import { SectionStore } from '@/feature/Offerte/OfferEvaluation/SectionStore';

    @Component({})
    export default class PgaOfferEvaluationHeaderCustomerOrderCreate extends mixins(SharedMixin)
    {
        @Prop({ type: Boolean, default: false }) readonly readonly! : boolean;

        private dropdownLoading = false;
        private showDynamicDropdown = false;
        private _timerId!: ReturnType<typeof setTimeout>;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        private readonly orderTipology : Array<any> = 
        [
            {
                Name: 'New',
                Value: 1,
            },
            {
                Name: 'Renewal',
                Value: 2,
            }
        ];

        get commandHeader() : CreateOfferEvaluationCustomerOrderHeaderCommand
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command;
        }

        get acom() : string
        {
            return SharedModule.Account?.name?.toUpperCase() ?? "";
        }

        get customerName() : string
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.CustomerName;
        }
        set customerName(value: string)
        {
            this.showDynamicDropdown = false;
            CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_CUSTOMERNAME(value);
        }
        private setCustomerNameManually(value: string)
		{
			CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_CUSTOMERNAME(value);

            // cancel pending call
            clearTimeout(this._timerId)

            if(value.length >= 3 && !this.customersDropdown.includes(value) && this._timerId != undefined)
            {
                // delay new call 500ms
                this._timerId = setTimeout(() =>
                {
                    this.requestCustomers(value);
                }, 500);
                this.showDynamicDropdown = true;
            }
            else
            {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                this._timerId = setTimeout(function() { }, 0);
            }
		}

        get offerDescription() : string
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.Description;
        }
        set offerDescription(value: string)
        {
            CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_DESCRIPTION(value);
        }

        get type() : OrderTipology
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.Type;
        }
        set type(value: OrderTipology)
        {
            CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_ORDERTYPE(value)
        }

        get masterAgreement() : boolean
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.MasterAgreement;
        }
        set masterAgreement(value: boolean)
        {
            CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_MASTERAGREEMENT(value);
        }

        // CRM
        get crmDealId() : string
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.CRMDealId;
        }

        get crmAmount() : number
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.CRMAmount;
        }

        get crmLastUpdate() : Date
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Command.CRMLastUpdate;
        }

        get customersDropdown() : Array<string>
		{
			return SectionStore.CustomersDropdown.map(c => c.BusinessName);
		}

        private async requestCustomers(search: string) : Promise<void>
		{
			this.dropdownLoading = true;
			await SectionStore.GetCustomersDropdown(search);
			this.dropdownLoading = false;
		}

        get Errors() : Map<string, Array<string>>
        {
            return CustomerOrderStore.CreateCustomerOrderHeader.Errors;
        }

        beforeDestroy() : void
        {
            CustomerOrderStore.SET_CREATE_CUSTOMERORDER_HEADER_ERRORS(new Map<string, Array<string>>());
            CustomerOrderStore.ResetCreateCustomerOrderCommand();
        }
    }
